import React from 'react';
import SurveyView from './survey.view';
import { TSurveyList } from '../../../apis/v1/survey.api';

interface SurveyProps {
  surveyPageData?: TSurveyList;
}

const Survey = ({ surveyPageData }: SurveyProps) => {
  return <SurveyView surveyPageData={surveyPageData} />;
};

export default Survey;
